import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type FormButtonProps } from "@client/controls/Form/component";
import { connectCustom } from "@client/lib/misc";
import { type AppState, Status } from "@client/types";
import Component, { type ActionProps, type MapProps } from "../Button/component";
import { sendResetLink } from "../actions";
import { localStateSelector } from "../selectors";
import { type LoginForm } from "../types";

type Props = RootContainerProps & FormButtonProps;
const makeMapStateToProps = () => {
  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      captionKey: "sendResetLink",
      isDisabled: localState.status === Status.Saving
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClick: (data: LoginForm.View.SendResetLinkFormData) => dispatch(sendResetLink(getEntityRef(props), data))
});

const SendResetLinkButton = connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);

export default SendResetLinkButton;
